export default __webpack_public_path__ + "static/media/equalizer.ff745dac.webp";